import { render, staticRenderFns } from "./DysfunctionV2.vue?vue&type=template&id=1ff76939&scoped=true"
import script from "./DysfunctionV2.vue?vue&type=script&lang=js"
export * from "./DysfunctionV2.vue?vue&type=script&lang=js"
import style0 from "./DysfunctionV2.vue?vue&type=style&index=0&id=1ff76939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff76939",
  null
  
)

export default component.exports